import { Component, OnInit, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import Swal from 'sweetalert2';

import { InvoicePreviewComponent } from '@teem/invoices-module/modals/invoice-preview/invoice-preview.component';
import { InvoiceDeliverableForm } from '@teem/model-forms/invoice-deliverable-form';
import { SharedDataService } from '@teem/services/shared-data.service';
import { ACTIONS as INVOICE_ACTIONS } from '@teem/constants/invoice';
import { ONLINE_PAYMENT_LIMIT as _ONLINE_PAYMENT_LIMIT } from '@teem/constants/invoice';
import { Select2Directive } from "@teem/directives/select2.directive";
import { InvoiceDeliverable } from '@teem/models/invoice-deliverable';
import { InvoiceService } from '@teem/services/invoice.service';
import { LoaderService } from '@teem/services/loader.service';
import { environment } from '@teem/environments/environment';
import { InvoiceForm } from '@teem/model-forms/invoice-form';
import { messages as i18n } from "@teem/constants/messages";
import { UserService } from '@teem/services/user.service';
import { client as ClientApi, general as GeneralAPI  } from '@teem/constants/api';
import { parseDate } from '@teem/helpers/functions';
import { Invoice } from '@teem/models/invoice';
import { AddClientModalComponent } from '@teem/invoices-module/modals/add-client-modal/add-client-modal.component';
import * as COUNTRIES from '@teem/constants/country';


@Component({
  selector: 'edit-invoice',
  templateUrl: './edit-invoice.component.html',
  styleUrls: ['./edit-invoice.component.scss']
})
export class EditInvoiceComponent implements OnInit {
  @Output() onUpdate: EventEmitter<any> = new EventEmitter();
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() changeTab: EventEmitter<any> = new EventEmitter();
  @ViewChild(Select2Directive) select2Directive = null
  @Input() invoiceDetail: Invoice;
  @Input() userInfo: any;
  invoiceForm: FormGroup;
  deliverables: FormArray;
  deliverableForm: FormGroup;
  submitted: boolean = false;
  selectedClient: any;
  selectedCurrency: any;
  isTaxInvoice: boolean = false;
  taxIncludesValues: any = 2;
  commonData: any;
  defaultAdditionalInfo: string = '';
  productAndServices: any;
  qrCodeBase64: string = '';
  COUNTRIES: any = COUNTRIES;

  projectTypes: object[] = [
    { value: 'fixed', 'label': $localize`:@@ts.common.fixed:Fixed` },
    { value: 'hourly', 'label': $localize`:@@ts.common.hourly:Hourly` },
  ];
  taxIncludeTypes: any = [
    { name: $localize`:@@ts.common.exclusive_of_tax:Exclusive of Tax`, id: '1' },
    { name: $localize`:@@ts.common.inclusive_of_tax:Inclusive of Tax`, id: '2' },
    { name: $localize`:@@ts.common.not_applicable:Not Applicable`, id: '3' },
  ];
  discountTypes: any = [
    { name: 'Percentage', id: 'percentage' },
    { name: 'Amount', id: 'amount' },
  ];
  discountType: string = 'percentage';
  clientListApi: string = ClientApi.list;
  currencyListApi: any = GeneralAPI.currencies;
  onlinePaymentLimit = _ONLINE_PAYMENT_LIMIT;
  itemTitle: string = i18n.invoice.add_new_item; //'Add New Item';
  addNewClientTitle: string = i18n.client.add_new_client; //'Add New Client';
  paymentForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    iban: new FormControl('', [Validators.required]),
    account_number: new FormControl('', [Validators.required]),
    bank_name: new FormControl('', [Validators.required]),
    country: new FormControl('', [Validators.required])
  });

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private loaderService: LoaderService,
    private invoiceService: InvoiceService,
    private userService: UserService,
    private sharedDataService: SharedDataService) {

  }

  ngOnInit() {
    this.invoiceForm = this.fb.group(new InvoiceForm(this.invoiceDetail ? this.invoiceDetail : new Invoice()))
    this.deliverables = this.invoiceForm.get('items') as FormArray;
    this.deliverableForm = this.fb.group(new InvoiceDeliverableForm(new InvoiceDeliverable));

    this.invoiceService.commonData().subscribe((data: any) => {
      this.commonData = data;
      this.isTaxInclusivePresent();
      // this.invoiceForm.get('invoice_number').setValue(data.next_invoice_number);
      if (data.tax_percent && data.tax_number) {
        this.isTaxInvoice = true;
      } else {
        this.enableTax(false);
        this.taxIncludeTypes = [{ name: $localize`:@@ts.common.not_applicable:Not Applicable`, id: '3' }];
        this.invoiceForm.get('tax_type').setValue(3);
        this.taxIncludesValues = 3;
      }

      this.selectedCurrency = {
        id: this.commonData?.currencies?.currency_code,
        currency_code: this.commonData?.currencies?.currency_code,
        currency_symbol: this.commonData?.currencies?.currency_symbol,
        currency_full_name: this.commonData?.currencies?.currency_full_name
      }
    });


    if (this.invoiceDetail.tax_type) {
      this.taxIncludesValues = this.invoiceDetail.tax_type;
    }
    
    if (this.invoiceDetail.payment_info && this.invoiceDetail.payment_info.name) {
      this.paymentForm.setValue(this.invoiceDetail.payment_info)
    }

    if (this.invoiceDetail?.currency) {
      this.userInfo.currency_symbol = this.invoiceDetail?.currency;
    }

    if (this.invoiceDetail.invoice_date) {
      let invoiceDate = moment(this.invoiceDetail.invoice_date).format('DD-MM-YYYY')
      this.invoiceForm.get('invoice_date').setValue(invoiceDate);
    }
    
    if (this.invoiceDetail?.tax_percent) {
      this.invoiceForm.get('tax_percent').setValue(this.invoiceDetail?.tax_percent);
      this.invoiceForm.get('include_tax').setValue(true);
      this.enableTax(true);
    }

    if (this.invoiceDetail?.discount_type) {
      this.discountType = this.invoiceDetail?.discount_type;
      this.invoiceForm.get('discount_type').setValue(this.invoiceDetail.discount_type);
    }

    this.defaultAdditionalInfo = this.invoiceDetail?.additional_info;
    this.invoiceForm.get('additional_info').setValue(this.defaultAdditionalInfo)

    if (this.invoiceDetail?.client_id) {
      this.invoiceForm.get('client_id').setValue(this.invoiceDetail.client_id);
      this.selectedClient = {
        id: this.invoiceDetail?.client.id,
        full_name: this.invoiceDetail?.client.full_name,
        email: this.invoiceDetail?.client.email
      }
    }

    this.fetchProductAndServices();
    this.validateBuyerInfo();

  }

  fetchProductAndServices() {
    this.invoiceService.getProductAndServices().subscribe((data: any) => {
      if (data.length) {
        data.unshift({ 'id': '__add_new_items__', 'text': this.itemTitle })
        this.productAndServices = data;
      } else {
        this.productAndServices = [{ 'id': '__add_new_items__', 'text': this.itemTitle }];
      }
    });
  }

  changeInvoiceType(event) {
    let invoiceType = this.invoiceForm.get('invoice_type');
    invoiceType.setValue(event);
    this.validateBuyerInfo();
  }

  validateBuyerInfo() {
    if (this.invoiceForm.controls.invoice_type.value == 'b2b') {
      ['invoice_time', 'buyer_first_name', 'buyer_last_name', 'buyer_address', 'buyer_vat_number', 'buyer_cr_number']?.forEach((field: string) => {
        this.invoiceForm.get(field).setValidators([Validators.required]);
        this.invoiceForm.get(field).updateValueAndValidity();
      });
    } else {
      ['invoice_time', 'buyer_first_name', 'buyer_last_name', 'buyer_address', 'buyer_vat_number', 'buyer_cr_number']?.forEach((field: string) => {
        this.invoiceForm.get(field).setValue(null);
        this.invoiceForm.get(field).clearValidators();
        this.invoiceForm.get(field).updateValueAndValidity();
      });
    }
  }

  changeQuantity(deliverable, type) {
    let value = deliverable.controls.quantity.value;
    if (type == 'plus') {
      if (deliverable?.value?.available_quantity <= value  && deliverable?.value?.type == 'product') {
        Swal.fire({title: i18n.warning, text: i18n.invoice.out_of_stock, icon: 'warning' })
        return false;
      }
      deliverable.controls.quantity.setValue(value + 1);
    } else if (type == 'minus' && value > 1) {
      deliverable.controls.quantity.setValue(value - 1);
    }
  }

  changeInputQuantityIfValueNullOrZero(deliverable) {
    let value = deliverable.controls.quantity.value;
    if (value == null || value <= 0) {
      deliverable.controls.quantity.setValue(1);
    }
  }

  changeInputQuantity(deliverable) {
    let value = deliverable.controls.quantity.value;
    if (deliverable?.value?.available_quantity < value  && deliverable?.value?.type == 'product') {
      Swal.fire({
        title: i18n.warning,
        text: i18n.invoice.out_of_stock,
        icon: 'warning'
      })
      deliverable.controls.quantity.setValue(deliverable?.value?.available_quantity);
    }
  }

  changeDiscount(value: number) {
    this.calculateOriginalAmount();
    this.calculateDiscountedAmount();
  }

  changeDiscountType(event) {
    this.discountType = event;
    let discountAmount = this.invoiceForm.get('discount');
    discountAmount.setValue(null);
    if (event != 'percentage') {
      discountAmount.clearValidators();
    } else {
      discountAmount.setValidators([Validators.min(0),Validators.max(100)]);
    }
    discountAmount.updateValueAndValidity();
    this.invoiceForm.get('discount_type').setValue(event);
    this.calculateOriginalAmount();
    this.calculateDiscountedAmount();
  }

  isTaxInclusive(event) {
    if (event == 1) {
      this.invoiceForm.get('include_tax').setValue(true);
      this.isTaxable(true);
    }
    if (event == 2) {
      this.invoiceForm.get('include_tax').setValue(true);
      this.isTaxable(true);
    }
    if (event == 3) {
      this.invoiceForm.get('include_tax').setValue(false);
      this.isTaxable(false);      
    }

    let taxPercent = this.invoiceForm.get('tax_percent');
    if (event == 3) {
      taxPercent.setValue(null);
      taxPercent.clearValidators();
    } else {
      taxPercent.setValidators([Validators.required,Validators.min(0),Validators.max(100)]);
    }
    taxPercent.updateValueAndValidity();

    this.calculateOriginalAmount();
    this.calculateDiscountedAmount();
  }

  get taxInvoice() {
    const invoiceFormValues = this.invoiceForm.value;
    if (this.taxAmount || (invoiceFormValues.tax_type == 1 || invoiceFormValues.tax_type == 2)) {
      return true;
    }
    return false;
  }
  
  get prefTextColor() {
    return `${this.userInfo.preference.text_color} !important;`;
  }

  get taxAmount() {
    let items = this.deliverables ? this.deliverables.value : [];
    if (items && items.length > 0) {
      return items.reduce((a, b) => a + this.deliverableTaxWithDiscountAmount(b), 0);
    }
    return 0;
  }

  deliverableTax(deliverable: any) {
    let value = deliverable.quantity * deliverable.rate;
    const invoiceFormValues = this.invoiceForm.value;
    if (invoiceFormValues.tax_type == 2) {
      if ((invoiceFormValues.include_tax && invoiceFormValues.tax_percent && deliverable.is_taxable)) {
        return ((value / (1 + invoiceFormValues.tax_percent / 100)) * (invoiceFormValues.tax_percent / 100))
      }
      return 0;
    } else if (invoiceFormValues.tax_type == 3) {
      return 0;
    }
    
    if ((invoiceFormValues.include_tax && invoiceFormValues.tax_percent && deliverable.is_taxable)) {
      return (value * invoiceFormValues.tax_percent / 100);
    }
    return 0;
  }

  deliverableTaxWithDiscountAmount(deliverable: any) {
    let itemTotal = deliverable.quantity * deliverable.rate;
    let discountAmount = this.invoiceForm.get('discount').value;
    discountAmount = parseFloat(discountAmount).toFixed(2);
    if (discountAmount > 0) {
      if (this.discountType == 'percentage') {
        discountAmount = ((itemTotal / (100) * (discountAmount)));
      }
    } else {
      discountAmount = 0;
    }
    
    let value = itemTotal - discountAmount;
    const invoiceFormValues = this.invoiceForm.value;
    if (invoiceFormValues.tax_type == 2) {
      if ((invoiceFormValues.include_tax && invoiceFormValues.tax_percent && deliverable.is_taxable)) {
        return ((value / (1 + invoiceFormValues.tax_percent / 100)) * (invoiceFormValues.tax_percent / 100))
      }
      return 0;
    } else if (invoiceFormValues.tax_type == 3) {
      return 0;
    }
    return (invoiceFormValues.include_tax && invoiceFormValues.tax_percent && deliverable.is_taxable) ? (value * invoiceFormValues.tax_percent / 100) : 0;
  }
  
  get newDeliverableTax() {
    const invoiceFormValues = this.invoiceForm.value;
    if (invoiceFormValues.include_tax && invoiceFormValues.tax_percent) {
      if (invoiceFormValues.tax_type == 1) {
        return (this.invoiceOriginalAmount * invoiceFormValues.tax_percent / 100);
      } else if (invoiceFormValues.tax_type == 2) {
        return (((this.invoiceOriginalAmount) / (1 + invoiceFormValues.tax_percent / 100)) * (invoiceFormValues.tax_percent / 100))
      }
    }
    return 0;
  }

  onChangeClient(value: any) {
    if (value) {
      if (value.id == '__add_new_items__') {
        this.select2Directive.clear();
        const modalRef = this.modalService.open(AddClientModalComponent);

        // Set id on modal dialog
        modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentNode.id = "newClient";

        modalRef.result.then(result => {
          this.selectedClient = {
            id: result.id,
            full_name: result.full_name,
            email: result.email
          }
          this.invoiceForm.get('client_id').setValue(result.id)
        });
      } else {
        this.selectedClient = {
          id: value.id,
          full_name: value.full_name,
          email: value.email
        }

        if (this.invoiceForm?.value?.invoice_type == 'b2b') {
          this.invoiceForm.get('buyer_first_name').setValue(value?.buyer_first_name);
          this.invoiceForm.get('buyer_last_name').setValue(value?.buyer_last_name);
          this.invoiceForm.get('buyer_address').setValue(value?.buyer_address);
          this.invoiceForm.get('buyer_vat_number').setValue(value?.buyer_vat_number);
          this.invoiceForm.get('buyer_cr_number').setValue(value?.buyer_cr_number);
        }
      }
    }
  }

  onChangeCurrency(value: any) {
    if (value) {
      this.selectedCurrency = {
        id: value.currency_code,
        currency_code: value.currency_code,
        currency_symbol: value.currency_symbol,
        currency_full_name: value?.currency_full_name
      }
      this.userInfo.currency_symbol = this.selectedCurrency?.currency_symbol;
    }
  }

  addDeliverable(form: FormGroup) {
    let items = this.deliverables ? this.deliverables.value : [];
    const index = items.findIndex((e) => e.title === form.value.title);
    if (index === -1) {
      form.value.available_quantity = (form.value.available_quantity == undefined || form.value.available_quantity == null) ? undefined : form.value.available_quantity;
      const currentDeliverbles = this.invoiceForm.get('items') as FormArray
      currentDeliverbles.push(
        this.fb.group(
          new InvoiceDeliverableForm(new InvoiceDeliverable(form.value))
        )
      )

      this.deliverables = this.invoiceForm.get('items') as FormArray;
      setTimeout(() => {
        if (form.value.type && this.invoiceForm.controls.include_tax.value) {
          this.enableTax(true);
        }
        form.controls.is_taxable.setValue((this.invoiceForm.controls.include_tax.value > 0) ? 1 : 0);
      }, 100);
    } else {
      this.changeQuantity(this.deliverables.controls[index], 'plus');
    }
    this.generateQrCode();
  }

  removeDeliverable(index: number) {
    const currentDeliverbles = this.invoiceForm.get('items') as FormArray;
    currentDeliverbles.removeAt(index)
    this.deliverables = currentDeliverbles;
  }

  enableTax(value: boolean) {
    let taxPercentControl = this.invoiceForm.get('tax_percent');
    if (value) {
      taxPercentControl.setValidators([Validators.required]);
    } else {
      taxPercentControl.setValue(null);
      taxPercentControl.clearValidators();
    }
    taxPercentControl.updateValueAndValidity();

    const deliverables = this.invoiceForm.get('items') as FormArray;

    let control;
    for (control of deliverables?.controls) {
      control.controls.is_taxable.setValue(value ? 1 : 0);
    }

    this.deliverableForm.controls.is_taxable.setValue(value ? 1 : 0);
    this.deliverables = deliverables;
  }

  isTaxable(value: boolean) {
    const deliverables = this.invoiceForm.get('items') as FormArray;
    let control;
    for (control of deliverables?.controls) {
      control.controls.is_taxable.setValue(value ? 1 : 0);
    }
    this.deliverableForm.controls.is_taxable.setValue(value ? 1 : 0);
    this.deliverables = deliverables;
  }

  validate() {
    let deliverables = this.invoiceForm.get('items').value;
    if (deliverables.length == 0) {
      Swal.fire({
        title: i18n.warning,
        text: i18n.invoice.please_add_deliverable,
        icon: 'warning'
      })
    } else {
      this.submitted = true;
      if (this.invoiceForm.valid && (!this.hasPaymentInfo || this.paymentForm.valid)) {
        return true
      }
    }

    return false;
  }

  saveAsDraft() {
    if (this.validate()) {
      this.invoiceForm.get('is_draft').setValue(1);
      this.invoiceForm.get('action').setValue('draft');
      this.isInvoiceTotalExceeds();
    }
  }

  // async saveAsPdf() {
  //   if (this.validate()) {
  //     try {
  //       this.invoiceForm.get('is_draft').setValue(0);
  //       let data: any = await this.isInvoiceTotalExceeds();

  //       // To-do : change option "_blank" to "_self" when download invoice url is ready
  //       // (window as any).open(`${environment.baseUrl}/download/invoice/${data.uuid}/pdf?lang=${(window as any).LOCALE}`, '_self');
  //       (window as any).open(`${environment.baseUrl}/download-invoice/${this.invoiceDetail.uuid}/pdf?lang=${(window as any).LOCALE}`, '_blank');
  //     } catch (err) {
  //       console.error('promise error')
  //     }
  //   }
  // }

  // saveAndEmail() {
  //   if (this.validate()) {
  //     this.invoiceForm.get('is_draft').setValue(0);
  //     this.invoiceForm.get('action').setValue(INVOICE_ACTIONS.EMAIL);
  //     this.isInvoiceTotalExceeds();
  //   }
  // }

  // saveAndWhatsapp() {
  //   if (this.validate()) {
  //     this.invoiceForm.get('is_draft').setValue(0);
  //     this.invoiceForm.get('action').setValue(INVOICE_ACTIONS.WHATSAPP);
  //     this.isInvoiceTotalExceeds();
  //   }
  // }

  saveInvoice() {
    if (this.validate()) {
      this.calculateOriginalAmount();
      this.calculateDiscountedAmount();
      this.calculateDueAmount();
      this.invoiceForm.get('is_draft').setValue(0);
      this.invoiceForm.get('action').setValue(null);
      this.isInvoiceTotalExceeds();
    }
  }

  generateQrCode() {
    if (this.taxIncludesValues != 3) {
      let invoiceInfo = this.invoiceForm.value;
      invoiceInfo.client = this.selectedClient;
      invoiceInfo.invoice_date = parseDate(invoiceInfo.invoice_date);    
      if (this.userInfo.country_id == COUNTRIES.SAUDI_ARABIA) {
        this.invoiceService.getInvoiceQrCode(invoiceInfo).subscribe((data: any) => {
          this.loaderService.stopLoading();
          if (data.status == 'success') {
            this.qrCodeBase64 = data.qr_code_base64;
          }
        }, err => {
          this.loaderService.stopLoading();
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        })
      }
    }    
  }


  getObjectValues(obj: any) {
    return obj ? Object.values(obj) : [];
  }

  get hasPaymentInfo() {
    let status: boolean = false;

    Object.values(this.paymentForm.value).forEach((value) => {
      if (value)
        status = true;
    });

    return status;
  }

  private submit() {

    this.calculateOriginalAmount();
    this.calculateDiscountedAmount();
    this.calculateDueAmount();
    this.invoiceForm.get('total_amount').setValue(this.invoiceTotal);

    return new Promise((resolve, reject) => {
      this.loaderService.startLoading();

      let fd: any = this.invoiceForm.value;
      fd.invoice_date = parseDate(fd.invoice_date);

      if (this.paymentForm.valid) {
        fd.payment_info = this.paymentForm.value
      }

      // Update Invoice
      fd.uuid = this.invoiceDetail.uuid;
      this.invoiceService.update(fd).subscribe((r) => {
        this.loaderService.stopLoading();

        let msg = i18n.invoice_saved; //"Invoice successfully saved.";

        if (fd.action == INVOICE_ACTIONS.WHATSAPP) {
          msg = i18n.invoice.invoice_saved_and_whatsapp_sent; // "Invoice successfaully saved and Whatsapp message sent."
        } else if (fd.action == INVOICE_ACTIONS.EMAIL) {
          msg = i18n.invoice.invoice_saved_and_email_sent //"Invoice successfaully saved and Email sent."
        }

        Swal.fire(i18n.done, i18n.invoice.invoice_updated, 'success').then(() => {
          this.invoiceForm = this.fb.group(new InvoiceForm(new Invoice()))
          this.deliverables = this.invoiceForm.get('items') as FormArray;

          this.onUpdate.emit(fd.action);
        });
        this.submitted = false;
        resolve(r);
      }, (err) => {
        this.loaderService.stopLoading();

        // Set server side error
        if (err.status === 422) {
          if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
            let validationErrors = err.error.errors;

            Object.keys(validationErrors).forEach((prop) => {
              this.invoiceForm.get(prop)?.setErrors({
                serverError: validationErrors[prop]
              })
            })
          }
        }

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');

        // reject(err);
      })
    });
  }

  isInvoiceTotalExceeds() {
    if (this.userInfo.accept_credit_card && this.userInfo.is_contract_sign && (this.invoiceTotal < 1 || this.invoiceTotal >= this.onlinePaymentLimit)) {
      Swal.fire({
        text: i18n.invoice.credit_card_payments_will_be_hidden_as_a_payment_method_if_your_invoice_total_exceeds,
        icon: 'warning',
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: i18n.ok,
      }).then(result => {
        if (result.value) {
          this.submit();
        }
      })
    } else {
      this.submit();
    }
  }

  isTaxInclusivePresent() {
    this.commonData.tax_percent == null ? this.commonData.tax_percent = 0 : this.commonData.tax_percent;
    return this.commonData.tax_percent == 0 ? false : true;
  }

  get taxAmountToInvoiceTotal() {
    const invoiceFormValues = this.invoiceForm.value;
    if (invoiceFormValues.tax_type == 1) {
      let items = this.deliverables ? this.deliverables.value : [];
      if (items && items.length > 0) {
        return items.reduce((a, b) => a + this.deliverableTaxWithDiscountAmount(b), 0);
      }
    }
    return 0;
  }

  deliverableCost(deliverable: any) {
    let value = deliverable.quantity * deliverable.rate;
    const invoiceFormValues = this.invoiceForm.value;
    if (!isNaN(value)) {
      if (invoiceFormValues.include_tax && invoiceFormValues.tax_percent && deliverable.is_taxable) {
        if (invoiceFormValues.tax_type == 2 || invoiceFormValues.tax_type == 3) {
          value = value;// + (value / (1 + (invoiceFormValues.tax_percent / 100)));
        } else {
          value = value + value * invoiceFormValues.tax_percent / 100;
        }
      }
      return value;
    }
    return 0;

    // let value = deliverable.quantity * deliverable.rate + this.deliverableTax(deliverable);

    // if (!isNaN(value)) {
    //   return value;
    // }
    // return 0;
  }

  // deliverableCost(deliverableValues: any) {
  //   let value = deliverableValues.quantity * deliverableValues.rate;
  //   if (!isNaN(value)) {
  //     return value;
  //   }
  //   return 0;
  // }

  calculateDueAmount() {
    this.invoiceDetail.due_amount = this.invoiceTotal;
  }

  calculateOriginalAmount() {
    this.invoiceForm.get('original_amount').setValue(this.invoiceOriginalAmount);
    this.generateQrCode();
  }

  calculateDiscountedAmount() {
    this.invoiceForm.get('discounted_amount').setValue(this.invoiceDiscountAmount);
  }

  get invoiceTotal() {
    let value = this.invoiceOriginalAmount;
    const invoiceFormValues = this.invoiceForm.value;
    if (invoiceFormValues.include_tax && invoiceFormValues.tax_percent) {
      if (invoiceFormValues.tax_type == 3 || invoiceFormValues.tax_type == 2) {
        value = value;
      } else {
        // value = value + (value * invoiceFormValues.tax_percent / 100);
        value = value + this.taxAmountToInvoiceTotal;
      }      
    }
    return value + this.invoiceDeliveryFeeAmount;
  }

  // get invoiceTotal() {
  //   let value = this.invoiceOriginalAmount;
  //   const invoiceFormValues = this.invoiceForm.value;
  //   if (invoiceFormValues.include_tax && invoiceFormValues.tax_percent) {
  //     if (invoiceFormValues.tax_type == 3 || invoiceFormValues.tax_type == 2) {
  //       value = value;
  //     } else {
  //       value = value + (value * invoiceFormValues.tax_percent / 100);
  //     }      
  //   }
  //   return value + this.invoiceDeliveryFeeAmount;
  // }

  get invoiceOriginalAmount() {
    return (this.subTotalDeliverableCost - this.invoiceDiscountAmount);
  }

  get invoiceDiscountAmount() {
    let discountAmount = this.invoiceForm.get('discount').value;
    discountAmount = parseFloat(discountAmount).toFixed(2);
    if (discountAmount > 0) {
      if (this.discountType != 'percentage') {
        return discountAmount;
      }
      return (((this.subTotalDeliverableCost) / (100) * (discountAmount)));
    }
    return 0;
  }

  get invoiceDeliveryFeeAmount() {
    if (this.invoiceForm.get('delivery_fee').value > 0) {
      let deliveryFee = this.invoiceForm.get('delivery_fee').value;
      return Number(deliveryFee);
    }
    return 0;
  }

  get subTotalDeliverableCost(){
    let items = this.deliverables ? this.deliverables.value : [];
    if (items && items.length > 0) {
      return items.reduce((a, b) => a + this.deliverableCost(b), 0);
    }
    return 0;
  }


}
